import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatExpansionPanel, MatSidenav } from '@angular/material';
import { Usuario } from '@tivic-team/manager-ts/dist/seg';
import { Modules } from 'app/core/application/features/modules';
import { LocalStorageService } from 'app/services/local-storage.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
    
    usuario: Usuario;
    environment = environment;
    date: Date = new Date();

    routerInUse: boolean = false;
    
    navMode = 'side';
    navOpened = true;
    get navFixed(): boolean {
        if(this._localStorageService.getValue('navFixed') == null)
            return true;
            
        return JSON.parse(this._localStorageService.getValue('navFixed'));
    }

    @Input('size') size: 'mini' | 'normal' = 'mini';
    get isMini(): boolean {
        return this.size === 'mini' && !this.navFixed
    }
    
    @Input('itens') itens = [];

    @ViewChild(MatSidenav, { static: false }) matSidenav: MatSidenav;
    @ViewChildren(MatExpansionPanel) expansion: QueryList<MatExpansionPanel>;

    constructor(
        public _modules: Modules,
        private _localStorageService: LocalStorageService
    ) { }

    async ngOnInit() {
        this.usuario = this._localStorageService.usuario;
        //console.log(this._modules.currentChange$.subscribe(console.log));
    }

    ngAfterViewInit() {
    }

    openNav($event) {
        this.navOpened = true;
    }

    changeSize($event, size) {
        if(this.navFixed) {
            return;
        }

        if(size == 'mini') {
            this.expansion.forEach(item => item.close());
        }
        this.size = size;
    }

    toggleFixed() {
        this._localStorageService.setValue('navFixed', !this.navFixed);
    }

}